module.exports = __webpack_public_path__ + "img/globe2.6147bff3.png";